import type { QueryKeyReturnType } from '@inflearn/codegen-wrapper';

import {
  API_ENDPOINT,
  useClientApiV1BlogsUserUserIdTagQuery,
} from '../../../resources/@types/uccSchema';

interface UseClientV1BlogsUserUserIdTagQuery {
  userId: number;
  options?: Parameters<typeof useClientApiV1BlogsUserUserIdTagQuery>[0]['options'];
}

export const blogsUserUserIdTagOptions = (userId: number) => {
  const url = API_ENDPOINT.CLIENT_V1_BLOGS_USER_USERID_TAG(String(userId));
  const queryKey = [url] as QueryKeyReturnType;

  return {
    queryKey,
    url,
  };
};

export function useBlogsUserUserIdTagQuery({
  userId,
  options,
}: UseClientV1BlogsUserUserIdTagQuery) {
  const { queryKey, url } = blogsUserUserIdTagOptions(userId);

  return useClientApiV1BlogsUserUserIdTagQuery({
    queryKey,
    url,
    options,
  });
}
